import { useQuery } from "@apollo/client/react";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";

import { constantsData, permissionsData, urlsData } from "@/data";
import { getClientQuery } from "@/graph";
import { openAlert, setCurrentClient } from "@/redux/actions";
import { canDo, displayErrorHandler } from "@/utils";

const useGetClient = (id) => {
    const { isAuthenticated } = useAuth0();

    const { t } = useTranslation();

    const dispatch = useDispatch();

    const { user } = useAuth0();

    const navigate = useNavigate();

    const { mediaRead: mediaReadPermission } = permissionsData.permissions.keys;

    const { data, error, loading } = useQuery(getClientQuery, {
        skip: !isAuthenticated || !canDo(user, [mediaReadPermission]),
        variables: {
            where: { id },
        },
    });

    useEffect(
        () => {
            if (!loading && data && !data.clientModel) navigate(urlsData.routes.notFound);
            if (data?.clientModel) dispatch(setCurrentClient(data.clientModel));
        },
        [data, loading], // eslint-disable-line
    );

    useEffect(
        () => {
            if (error?.message === constantsData.failedToFetch && !loading) {
                displayErrorHandler(t("messages.networkFailure"), dispatch, openAlert);
            }
        },
        [error, data], // eslint-disable-line
    );

    return {
        data: data?.clientModel,
        loading,
    };
};

export default useGetClient;
